import ConstructionIcon from '@mui/icons-material/Construction'
import { Box, Typography, Button, Card, CardContent } from '@mui/material'
import * as React from 'react'
import { useNavigate } from 'react-router'

export default function WorkInProgress() {
  const navigate = useNavigate()

  return (
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Card sx={{ maxWidth: 400 }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <ConstructionIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Coming Soon!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            We're working hard to bring you online booking functionality. This feature will be available soon!
          </Typography>
          <Button variant="contained" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </CardContent>
      </Card>
    </Box>
  )
}
